import { Inject, Injectable, InjectionToken, Provider } from '@angular/core';
import { ListStateService } from '@modules/common/components/list/list-state.service';
import { SortBy } from '@modules/common/types/SortBy';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';
import { StateService } from '@modules/settings/services/state.service';
import { StateKey } from '@modules/settings/types/state-key';
import { Sheet } from '../types/sheet';
import { SheetListSortField, SheetsListState } from '../types/sheets-list-state';

export interface SheetsListStateServiceConfig {
  stateKey?: StateKey;
  withAdvancedSearch?: boolean;
  defaultSort?: SortBy<SheetListSortField>;
}

export const SheetsListStateServiceConfigToken = new InjectionToken<SheetsListStateServiceConfig>(
  'Configuration object for sheets list state service',
);

@Injectable()
export class SheetsListStateService extends ListStateService<Sheet, SheetListSortField, SheetsListState> {
  declare public readonly state: SheetsListState;

  constructor(
    stateService: StateService,
    advancedSearchService: AdvancedSearchService,
    @Inject(SheetsListStateServiceConfigToken) config: SheetsListStateServiceConfig,
  ) {
    super();

    this.state = new SheetsListState({
      searchService: advancedSearchService,
      stateService: stateService,
      stateKey: config.stateKey,
      withAdvanced: config.withAdvancedSearch,
      defaultSort: config.defaultSort,
    });
  }

  public static providers(config: SheetsListStateServiceConfig = {}): Provider[] {
    return super.prepareProviders(SheetsListStateServiceConfigToken, config);
  }
}

declare module '@modules/settings/types/state' {
  export interface State {
    [StateKey.sheetsListState]?: SheetsListState;
    [StateKey.sheetsDPListState]?: SheetsListState;
  }
}
